import { render, staticRenderFns } from "./FollowUp.vue?vue&type=template&id=ef51415e&scoped=true"
import script from "./FollowUp.vue?vue&type=script&lang=js"
export * from "./FollowUp.vue?vue&type=script&lang=js"
import style0 from "./FollowUp.vue?vue&type=style&index=0&id=ef51415e&prod&scoped=true&lang=css"
import style1 from "./FollowUp.vue?vue&type=style&index=1&id=ef51415e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef51415e",
  null
  
)

export default component.exports